<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        <ds-card class="results-cross-sell" [elevated]="dsComponents?.dsCardStatic?.elevated" [variant]="dsComponents?.dsCardStatic?.variant">
            <div class="results-cross-sell-title text-truncate">{{ vm?.title }}</div>
            <div class="results-cross-sell-subtitle text-truncate">
                {{ vm?.description }}
            </div>
            <div class="results-cross-sell-content">{{ vm?.content }}</div>
            @if (vm?.checkOtherPromotions) {
                <a
                    href="#"
                    [onClickWebTracker]="{
                        LabelEvent: vm?.webAnalytic?.page,
                        ActionEvent: 'Check Other  - Click',
                        LocationEvent: vm?.webAnalytic?.tab,
                        EventDetails: vm?.webAnalytic?.promoId,
                        campaignId: vm?.webAnalytic?.campaignId,
                        messageType: vm?.webAnalytic?.messageType,
                    }"
                    (click)="checkOtherPromotions(vm?.checkOtherPromotions); $event.preventDefault()"
                    ds-button
                    [size]="vm?.checkOtherPromotions?.attributes['data-btn-size']"
                    [variant]="vm?.checkOtherPromotions?.attributes['data-btn-variant']"
                    [kind]="vm?.checkOtherPromotions?.attributes['data-btn-kind']"
                    class="results-cross-sell-cta"
                    >{{ vm?.checkOtherPromotionsText }}</a
                >
            }
        </ds-card>
    }
</ng-container>
